var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCircleRight = function SvgArrowCircleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M16 29.333c7.363 0 13.333-5.97 13.333-13.333S23.363 2.667 15.999 2.667 2.666 8.636 2.666 16s5.97 13.333 13.333 13.333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M8.882 16h12.952M16.639 22.476 23.115 16 16.64 9.524"
  })));
};
export default SvgArrowCircleRight;